<template>
    <div style="height:100%">
        <div class="nameSpan">
            <div style="line-height:24px;">欢迎使用</div>
            <div style="line-height:24px;">自助立案手机辅助填写</div>
        </div>
        <div class="form">
            <div class="top">
                <div><img src="../../../static/images/input.png" class="img" /></div>
                <div class="title">填写案件信息</div>
            </div>

            <div class="block">
                <van-field v-model="form.partyName" clearable label-width="100px" required label="当事人姓名"
                    placeholder="请输入当事人姓名" bind:click-icon="onClickIcon" style="background: rgb(247, 247, 247)" />
                <van-field v-model="form.partyIdcard" clearable label-width="100px" required label="当事人身份证"
                    placeholder="请输入当事人身份证" bind:click-icon="onClickIcon" style="background: rgb(247, 247, 247)" />
                <van-field v-model="form.partyMobile" clearable type="digit" label-width="100px" required label="当事人电话"
                    maxlength="11" placeholder="请输入电话" bind:click-icon="onClickIcon"
                    style="background: rgb(247, 247, 247)" />
                <div v-if="globalFlag">
                    <van-field readonly clickable name="picker" is-link v-model="form.acceptCourtName"
                        label-width="100px" required label="管辖法院" placeholder="点击选择管辖法院" @click="showAcceptCourt = true"
                        style="background: rgb(247, 247, 247)" />
                    <van-popup v-model="showAcceptCourt" position="bottom">
                        <van-picker show-toolbar :columns="acceptCourtColumns" @confirm="onConfirmAcceptCourt"
                            @cancel="showAcceptCourt = false" />
                    </van-popup>
                    <van-field readonly clickable name="area" is-link :value="form.serviceAreaCodeValue"
                        label-width="100px" required label="送达地区" placeholder="点击选择省市区" @click="showArea = true"
                        style="background: rgb(247, 247, 247)" />
                    <van-popup v-model="showArea" position="bottom">
                        <van-area :area-list="areaList" @confirm="onConfirm" @cancel="showArea = false" />
                    </van-popup>
                    <van-field v-model="form.serviceAddress" rows="2" autosize label-width="100px" required label="详细地址"
                        placeholder="请填写详细地址" type="textarea" style="background: rgb(247, 247, 247)" />
                </div>
            </div>
        </div>
        <div class="form">
            <div class="top">
                <div><img src="../../../static/images/select.png" class="img" /></div>
                <div class="title">选择案件信息</div>
            </div>
            <div class="block">
                <van-field readonly clickable name="picker" is-link :value="form.caseCategoryName" label-width="100px"
                    label="案件类别" required placeholder="点击选择案件类别" @click="caseCategoryClick"
                    style="background: rgb(247, 247, 247)" />
                <van-popup v-model="showCategory" position="bottom">
                    <van-picker show-toolbar :columns="caseCategoryColumns" @confirm="onConfirmCategory"
                        @cancel="showCategory = false" />
                </van-popup>
                <van-field readonly clickable name="picker" is-link :value="form.caseTypeName" required
                    label-width="100px" label="案件类型" placeholder="点击选择案件类型" @click="caseTypeClick"
                    style="background: rgb(247, 247, 247)" />
                <van-popup v-model="showType" position="bottom">
                    <van-picker show-toolbar :columns="caseTypeColumns" @confirm="onConfirmType"
                        @cancel="showType = false" />
                </van-popup>
            </div>
        </div>
        <div style="margin: 16px;">
            <van-button block type="info" @click="nextButton">
                下一步
            </van-button>
        </div>
    </div>
</template>

<script>
import { getAreaTreeByLevel } from '@api/center/area'
import { findTypeList } from '@api/center/master-case-type'
import { listByCityArea } from '@api/center/openCompany'
import companys from '../../../static/js/company'

import Vue from 'vue'
import '@vant/touch-emulator'
import { Toast, Picker, Popup } from 'vant'

Vue.use(Picker).use(Popup)
Vue.use(Toast)

export default {
    name: 'caseInpt',
    data() {
        return {
            roleFlag: false, // 默认原告
            form: {
                partyName: null, // 当事人姓名
                partyIdcard: null, // 当事人身份证
                partyMobile: null, // 当事人电话
                acceptCourt: null, // 管辖法院
                acceptCourtName: null, // 法院名称显示
                serviceAddress: null, // 送达地址
                serviceAreaCode: null, // 省市区code
                serviceAreaCodeValue: null, // 省市区名称
                caseCategory: null, // 案件类别code
                caseType: null, // 案件类型code
                caseCategoryName: null, // 案件类别名称
                caseTypeName: null, // 案件类型名称
            },
            companyList: [], // 法院列表
            acceptCourtColumns: [], // 法院名称列表

            showAcceptCourt: false,
            showArea: false,
            areaList: {}, // 数据格式见 Area 组件文档

            caseList: [],
            caseCategoryList: [],
            caseCategoryColumns: [],
            caseCategoryObj: {},
            caseTypeList: [],
            caseTypeColumns: [],
            caseTypeObj: {},
            showCategory: false,
            showType: false,
            globalFlag: true,
        }
    },
    mounted() {},
    methods: {
        // 初始化
        init() {
            if (this.$route.query.globalFlag == 'false') {
                this.globalFlag = false
            } else {
                this.globalFlag = true
            }
            if (this.$route.query.partyName) {
                this.form.partyName = this.$route.query.partyName
            }
            if (this.$route.query.partyIdcard) {
                this.form.partyIdcard = this.$route.query.partyIdcard
            }
            let acceptCourt = this.$route.query.areaCode
            if (acceptCourt) {
                this.form.acceptCourt = acceptCourt
            }

            this.findAreaList()
            this.findTypeList()
            this.initCompanyList()
        },

        // 获取省市区列表
        findAreaList() {
            var param = {}
            getAreaTreeByLevel(param).then((data) => {
                if (data.result) {
                    this.areaList = data.result
                }
            })
        },

        // 获取案件类型
        findTypeList() {
            var param = {}
            findTypeList(param).then((data) => {
                if (data.result) {
                    data.result.forEach((obj) => {
                        obj.isSelected = false
                    })
                    this.caseList = data.result
                }
            })
        },

        // 初始化管辖法院
        initCompanyList() {
            let areaCode = this.$route.query.areaCode
            listByCityArea(areaCode).then((data) => {
                let openCompanyList = data.result

                // 未配置对应法院
                if (null == openCompanyList || [] === openCompanyList) {
                    this.$message({
                        type: 'warning',
                        message: '请联系管理员配置对应法院信息',
                    })
                    return
                }

                this.companyList = openCompanyList
                this.acceptCourtColumns = []
                if (this.companyList && this.companyList.length) {
                    for (let item of this.companyList) {
                        this.acceptCourtColumns.push(item.name)
                    }
                }
            })
        },

        // 管辖法院
        onConfirmAcceptCourt(picker, value, index) {
            let company = this.companyList[value]
            this.form.acceptCourt = company.area
            this.form.acceptCourtName = company.name
            this.showAcceptCourt = false
        },

        // 省市区
        onConfirm(values) {
            this.form.serviceAreaCodeValue = values
                .map((item) => item.name)
                .join('')
            this.form.serviceAreaCode = values[2].code
            this.showArea = false
        },

        // 点击案件类别
        caseCategoryClick() {
            this.caseCategoryColumns = []
            if (this.caseList && this.caseList.length) {
                for (let item of this.caseList) {
                    this.caseCategoryColumns.push(item.caseTypeShortName)
                }
            }
            this.showCategory = true
        },

        // 点击案件类别
        caseTypeClick() {
            this.caseTypeColumns = []
            if (this.caseList && this.caseList.length) {
                for (let item of this.caseTypeList) {
                    this.caseTypeColumns.push(item.caseTypeShortName)
                }
            }
            this.showType = true
        },

        /**
         * 案件类别
         */
        onConfirmCategory(picker, value, index) {
            let caseCategoryObj = this.caseList[value]
            this.caseTypeList = caseCategoryObj.childMasterCaseTypeList
            this.form.caseCategory = caseCategoryObj.caseTypeCode
            this.form.caseCategoryName = caseCategoryObj.caseTypeShortName
            this.showCategory = false
        },

        /**
         * 案件类型
         */
        onConfirmType(picker, value, index) {
            let caseTypeObj = this.caseTypeList[value]
            this.form.caseType = caseTypeObj.caseTypeCode
            this.form.caseTypeName = caseTypeObj.caseTypeShortName
            this.showType = false
        },

        // 提交
        nextButton() {
            var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/
            if (this.form.partyName == null || this.form.partyName == '') {
                Toast('当事人姓名不能为空')
                return
            }
            if (this.form.partyIdcard == null || this.form.partyIdcard == '') {
                Toast('当事人身份证不能为空')
                return
            }
            if (this.form.partyMobile == null || this.form.partyMobile == '') {
                Toast('当事人电话不能为空')
                return
            } else if (
                this.form.partyMobile &&
                !reg.test(this.form.partyMobile)
            ) {
                Toast('手机号格式不正确')
                return
            }
            if (this.globalFlag) {
                if (
                    this.form.acceptCourt == null ||
                    this.form.acceptCourt == ''
                ) {
                    Toast('管辖法院不能为空')
                    return
                }
                if (
                    this.form.serviceAreaCode == null ||
                    this.form.serviceAreaCode == ''
                ) {
                    Toast('请选择省市区')
                    return
                }
                if (
                    this.form.serviceAddress == null ||
                    this.form.serviceAddress == ''
                ) {
                    Toast('详细地址不能为空')
                    return
                }
            }
            if (
                this.form.caseCategory == null ||
                this.form.caseCategory == ''
            ) {
                Toast('案件类别不能为空')
                return
            }
            if (this.form.caseType == null || this.form.caseType == '') {
                Toast('案件类型不能为空')
                return
            }
            this.$parent.goQrcode(this.form)
        },
    },
}
</script>
<style scoped>
.nameSpan {
    width: 100%;
    font-size: 20px;
    color: rgb(245, 165, 1);
    font-family: PingFang-SC-Medium;
    background: rgb(255, 251, 239);
    display: flex;
    flex-direction: column;
    padding: 10px 10px 10px 5%;
}

.form {
    width: 100%;
    margin-top: 10px;
}

.top {
    margin-left: 5%;
    width: 90%;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
}

.img {
    width: 20px;
    height: 26px;
}

.title {
    font-size: 18px;
    font-family: PingFang-SC-Medium;
    font-weight: bold;
    color: rgb(51, 51, 51);
    margin-left: 10px;
}

.block {
    width: 90%;
    margin-left: 5%;
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/case-input.vue